{
    "RestNoContentError": "O conteúdo da resposta era esperado, mas nenhum foi fornecido",
    "RestJsonProcessing": "Erro ao processar JSON",
    "NAME": "LanguageErrors",
    "UnhandlableError": "O serviço Akixi apresentou um erro impossível de gerir.",
    "UnknownError": "Ocorreu um erro de servidor desconhecido"
}